import React from "react";
import s from "./DataLakeVisual.module.scss";

const ICONS: Record<string, React.ReactNode> = {
  store: (
    <>
      <path d="M3 9l1.5-5h15L21 9" />
      <path d="M5 9v10h14V9" />
      <path d="M3 9h18" />
    </>
  ),
  bag: (
    <>
      <path d="M6 8h12l-1 12H7z" />
      <path d="M9 8a3 3 0 0 1 6 0" />
    </>
  ),
  monitor: (
    <>
      <rect x="3" y="4" width="18" height="13" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </>
  ),
  bike: (
    <>
      <circle cx="6" cy="17" r="3" />
      <circle cx="18" cy="17" r="3" />
      <path d="M6 17l4-8h5l3 8M9 9h6" />
    </>
  ),
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </>
  ),
  chat: <path d="M4 5h16v11H9l-5 4z" />,
};

interface Source {
  pos: string;
  title: string;
  sub: string;
  icon: string;
  color: string;
  path: string;
}

const SOURCES: Source[] = [
  { pos: "lt", title: "Retail data", sub: "POS & in-store", icon: "store", color: "#3b82f6", path: "M50 50 C40 42 35 22 30 14" },
  { pos: "lm", title: "Marketplace data", sub: "3P sellers & listings", icon: "bag", color: "#2665ff", path: "M50 50 C43 48 37 46 30 46" },
  { pos: "lb", title: "E-commerce data", sub: "Online storefronts", icon: "monitor", color: "#10b981", path: "M50 50 C40 58 35 70 30 78" },
  { pos: "rt", title: "Quick commerce", sub: "Rapid delivery", icon: "bike", color: "#f59e0b", path: "M50 50 C60 42 65 22 70 14" },
  { pos: "rm", title: "Vendor data", sub: "Suppliers & SKUs", icon: "grid", color: "#ef4444", path: "M50 50 C57 48 63 46 70 46" },
  { pos: "rb", title: "Social data", sub: "Reviews & signals", icon: "chat", color: "#ec4899", path: "M50 50 C60 58 65 70 70 78" },
];

export const DataLakeVisual = () => (
  <div className={s.lake}>
    {/* connectors + flowing data packets */}
    <svg className={s.connSvg} viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      {SOURCES.map((src) => (
        <path key={`c-${src.pos}`} className={s.conn} d={src.path} />
      ))}
      {SOURCES.map((src, i) => (
        <circle key={`p-${src.pos}`} className={s.pulse} r="1.1">
          <animateMotion
            dur="2.4s"
            begin={`${i * 0.35}s`}
            repeatCount="indefinite"
            keyPoints="1;0"
            keyTimes="0;1"
            calcMode="linear"
            path={src.path}
          />
        </circle>
      ))}
    </svg>

    {/* central hub */}
    <div className={s.hub}>
      <span className={s.hubRing} aria-hidden="true" />
      <span className={s.hubIcon}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <ellipse cx="12" cy="6" rx="7" ry="3" />
          <path d="M5 6v12c0 1.6 3.1 3 7 3s7-1.4 7-3V6" />
          <path d="M5 12c0 1.6 3.1 3 7 3s7-1.4 7-3" />
        </svg>
      </span>
      <span className={s.hubTitle}>Socommerz Data Lake</span>
      <span className={s.hubSub}>Unified, query-ready store</span>
    </div>

    {/* source cards */}
    {SOURCES.map((src) => (
      <div
        key={src.pos}
        className={`${s.card} ${s[src.pos]}`}
        style={{ "--c": src.color } as React.CSSProperties}
      >
        <span className={s.cardIcon}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {ICONS[src.icon]}
          </svg>
        </span>
        <span className={s.cardText}>
          <span className={s.cardTitle}>{src.title}</span>
          <span className={s.cardSub}>{src.sub}</span>
        </span>
      </div>
    ))}
  </div>
);
